<template>
<div class="chapter">
<div class="inner_page">
<h2 class="parttitle"><span class="bold">I. BEFORE THE WAR</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pt1.vue?6911eade